<div class="common-style h-100 d-flex flex-column">
  <div class="panel-header d-flex align-items-center justify-content-between">
    <div style="width: 48px;"></div>
    <h6 class="model-title mb-0 flex-grow-1 text-center">
      {{ data.mode === 'edit' ? 'Edit Service' : 'Add Service' }}
    </h6>
    <div class="d-flex align-items-center">
      <button type="button" mat-icon-button class="panel-close-btn" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="panel-body flex-grow-1 overflow-y-auto overflow-x-hidden">
    <form id="serviceDialogForm" [formGroup]="serviceForm" class="tab-content" (ngSubmit)="onSave()">
      <div class="col-sm-12 mb-3">
        <span class="title-name">Name <span class="mandatory-star">*</span></span>
        <div class="error-input-wrapper">
          <input type="text" class="form-control" placeholder="e.g., CDN" formControlName="name">
          @if (serviceForm.get('name')?.hasError('required') && serviceForm.get('name')?.touched) {
            <mat-error>Name is required</mat-error>
          }
          @if (serviceForm.get('name')?.hasError('minlength') && serviceForm.get('name')?.touched) {
            <mat-error>Name must be at least 3 characters</mat-error>
          }
          @if ((serviceForm.get('name')?.hasError('pattern') || serviceForm.get('name')?.hasError('invalidName')) && serviceForm.get('name')?.touched) {
            <mat-error>Name is invalid</mat-error>
          }
        </div>
      </div>

      <div class="col-sm-12 mb-3">
        <span class="title-name">Description</span>
        <div class="error-input-wrapper">
          <textarea class="form-control" rows="3" placeholder="e.g., Content delivery network"
            formControlName="description"></textarea>
          @if (serviceForm.get('description')?.hasError('invalidName') && serviceForm.get('description')?.touched) {
            <mat-error>Description is invalid</mat-error>
          }
        </div>
      </div>

      @if (data.mode === 'edit') {
      <div class="col-sm-12 status-field">
        <span class="title-name">Status</span>
        <span class="status-name text-dark">Operational</span>
      </div>
      }
    </form>
  </div>

  <div class="panel-footer d-flex justify-content-end gap-2 align-items-center">
    <button type="button" class="bt-border" mat-raised-button (click)="onCancel()" [disabled]="isSaving">Cancel</button>
    <button type="submit" class="bt-background ms-3" mat-raised-button [disabled]="isSaving || serviceForm.invalid" form="serviceDialogForm">
      @if (isSaving) {
        <mat-spinner diameter="16" class="d-inline-block me-2" style="vertical-align: middle;"></mat-spinner>
      }
      Add Service
    </button>
  </div>
</div>
